import { useContext } from 'react';
import firebase from 'firebase/app';
// eslint-disable-next-line import/no-extraneous-dependencies,no-unused-vars
import storage from 'firebase/storage';
import { Context as PayKeyDashboardServerContext } from '../context/PayKeyDashboardServerContext';

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  storageBucket: process.env.STORAGE_BUCKET,
};

firebase.initializeApp(firebaseConfig);
const storageRef = firebase.storage().ref();

export default function ServerGate() {
  const { updateUserByAdmin, getAllFiles, getFontFile } = useContext(
    PayKeyDashboardServerContext,
  );
  this.updateUserInServer = async (token,
    selectedUser,
    onSuccess,
    onFailed) => {
    await updateUserByAdmin(
      token,
      selectedUser.userId,
      selectedUser,
      onSuccess,
      onFailed,
    );
  };

  this.initializeMainConfigurations = async (mainConfigurations) => {
    await getAllFiles(mainConfigurations);
    await getFontFile(mainConfigurations.configurations.theme.fonts.custom_font);
    await getFontFile(mainConfigurations.configurations.theme.fonts.custom_bold_font);
  };

  this.getStorageRef = () => storageRef;
}
